import React from 'react'
import searchvec from '../assets/sub.svg'
const Header = () => {
  return ( 
    <>
        <div className='header-main my-5  '>
        <div className='w-full'>
        <div className='home-bg-wrap w-[90%] md:ml-[10%]  ml-[10%] md:h-[500px] h-[200px] rounded-l-full'>
              
            <div className='  mt-[8%] ml-[2%] flex'>
               <div className='   flex'>
               <span className=' h-16 md:h-32 rounded-xl mx-1 md:mx-5 mt-3  md:mt-8 border-2 border-gray-300 '></span>
               <span className=' h-16 md:h-32 rounded-xl mx-1 md:mx-5 mb-3  md:mb-8 border-2 border-gray-300 '></span>
               <span className=' h-16 md:h-32 rounded-xl mx-1 md:mx-5 mt-3  md:mt-8 border-2 border-gray-300 '></span>
               <span className=' h-16 md:h-32 rounded-xl mx-1 md:mx-5 mb-3  md:mb-8 border-2 border-gray-300 '></span>
               <span className=' h-16 md:h-32 rounded-xl mx-1 md:mx-5 mt-3  md:mt-8 border-2 border-gray-300 '></span>
               <span className=' h-16 md:h-32 rounded-xl mx-1 md:mx-5 mb-3  md:mb-8 border-2 border-gray-300 '></span>
               <span className=' h-16 md:h-32 rounded-xl mx-1 md:mx-5 mt-3  md:mt-8 border-2 border-gray-300 '></span>
               <span className=' h-16 md:h-32 rounded-xl mx-1 md:mx-5 mt-3  md:mt-8 border-2 border-gray-300 '></span>
                
               </div>
               <div className='   '>
             
             <h1 className='text-white text-lg md:text-[56px] font-bold leading-[115%] md:py-4 font-Outfit '>Lorem Ipsum  
             <span className='text-black '>  <br/> Ipsum<br/></span>
              dolor sit consectetur</h1>
            </div> 
            <div className=' flex'>
 
               <span className=' h-16 md:h-32 rounded-xl mx-1 md:mx-5 mb-3  md:mb-8 border-2 border-gray-300 '></span>
               <span className=' h-16 md:h-32 rounded-xl mx-1 md:mx-5 mt-3  md:mt-8 border-2 border-gray-300 '></span>
               <span className=' h-16 md:h-32 rounded-xl mx-1 md:mx-5 mb-3  md:mb-8 border-2 border-gray-300 '></span>
               <span className=' h-16 md:h-32 rounded-xl mx-1 md:mx-5 mt-3  md:mt-8 border-2 border-gray-300 '></span>
               <span className=' h-16 md:h-32 rounded-xl mx-1 md:mx-5 mb-3  md:mb-8 border-2 border-gray-300 '></span>
               <span className=' h-16 md:h-32 rounded-xl mx-1 md:mx-5 mt-3  md:mt-8 border-2 border-gray-300 '></span>
               <span className=' h-16 md:h-32 rounded-xl mx-1 md:mx-5 mb-3  md:mb-8 border-2 border-gray-300 '></span>               
               </div>
            </div>
            



            <div className=' md:w-[40%]  mx-auto w-[80%]  '>
 
                 <div className='flex'>
                 <img src={searchvec} alt='imgg' className=' absolute md:ml-5 md:mt-[12px] h-[30px] w-[40px] -mr-6 z-40 ml-3 pt-[4px]   px-2     '  />
                 {/* <i class="fa-solid fa-angles-down text-gray-300 text-sm md:text-2xl -mr-6 z-40 pt-2 md:pt-3 px-2 pl-6 absolute  "></i>/ */}
                                <input className='w-full ml-3  h-8 md:h-14  rounded-full pl-9 md:pl-12 outline-none md:text-[14px] text-xs ' type='text' placeholder='Search a padel court to book' />
                                <div className='bg-blue-200 cursor-pointer h-8 md:h-14 w-12 md:w-20 pt-1 md:pt-3 rounded-r-full -ml-10 md:-ml-16'>
                                    <i class="fa-solid fa-location-crosshairs cursor-pointer text-blue-600 ml-3 md:ml-5     text-sm md:text-2xl   "></i>

                                </div>
                 </div>
                 
             </div>
          </div>
          </div>
        </div>
    </>
  )
}
 
export default Header